import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, delay, map } from 'rxjs/operators';
import { ApiService } from '../core/api.service';
import { User } from '../core/models/user';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  isLoggedIn = false;

  readonly userDev = {
    accountStatus: "active",
    advancedLesson1Complete: "1",
    advancedLesson2Complete: "1",
    advancedLesson3Complete: "1",
    advancedLesson4Complete: "1",
    advancedLesson5Complete: "1",
    advancedLesson6Complete: "1",
    advancedLesson7Complete: "1",
    advancedLesson8Complete: "1",
    advancedLesson9Complete: "1",
    advancedLesson10Complete: "1",
    advancedLesson11Complete: "1",
    advancedLesson12Complete: "1",
    basicLesson1Complete: "1",
    basicLesson2Complete: "1",
    basicLesson3Complete: "1",
    basicLesson4Complete: "1",
    basicLesson5Complete: "1",
    basicLesson6Complete: "1",
    basicLesson7Complete: "1",
    basicLesson8Complete: "1",
    basicLesson9Complete: "1",
    basicLesson10Complete: "1",
    basicLesson11Complete: "1",
    bonusPoints: "0",
    courseExpired: "true",
    courseHours: "0",
    courseNumber: {},
    courseProgress: "0",
    courseProgressInfo: "100",
    expirationDate: "27-Jun-2020",
    firstTimeUser: "No",
    fullName: "bruger",
    howManyExams: "75",
    keyboard_in_use: "4",
    keysLearned: "60",
    language_in_use: "uk",
    lastExercise: "6",
    lastLesson: "6",
    password: "123456",
    problematicKey1: {},
    problematicKey1_no: "0",
    problematicKey2: {},
    problematicKey2_no: "0",
    problematicKey3: {},
    problematicKey3_no: "0",
    problematicKey4: {},
    problematicKey4_no: "0",
    speedExerciseReached: "12",
    startDate: "18-Jun-2019",
    surveyDisplayed: "true",
    surveyLink: "http://www.zoomerang.com/Survey/WEB22CX89TXG2Z",
    totalTime: "01h:56m",
    userid: "23789",
    username: "test1@test1.dk",
    ylrErrorPercent: "0",
    ylrGrade: "0",
    ylrSpeedExcercise: "0",
    ylrTimeUsed: "00:00:18",
    ylrTotalErrors: "0",
    ylrTotalKeyStrokes: "45",
    ylrWordsPerMinute: "0"
  } 

  // user info => should a class
  user$ = new BehaviorSubject<User>(undefined);

  // store the URL so we can redirect after logging in
  redirectUrl: string;

  constructor(
    private router: Router,
    private apiService: ApiService,
    private translateService: TranslateService) { }

  login(username: string, password: string): Observable<any> {
    return this.apiService.login(username, password)
    .pipe(      
      tap(value => {
        const user = value.users.user;

        if(user.userid > 0) {
          user.password = password;
          this.user$.next(user);
          this.isLoggedIn = true;

          // setup translation
          if(user.language_in_use === 'uk') {
            this.translateService.use('en');
          }
          if(user.language_in_use === 'dk') {
            this.translateService.use('da');
          }
          if(user.language_in_use === 'de') {
            this.translateService.use('de');
          }

        }        
      }),
      map(value => value.users.user)
    );
  }

  logout(): void {
    this.user$.next(undefined);
    this.isLoggedIn = false;
    this.router.navigate(['/login']);
  }



}
